import React from "react";
import EmailTemplates from "../../features/email-templates/EmailTemplates";

const EmailTemplatesPage: React.FC = () => {
  return <EmailTemplates />;
};

export default EmailTemplatesPage;
